import { Button, useDisclosure } from '@chakra-ui/react';
import React, { useState } from 'react';
import AddNewVariationModal from './AddNewVariationModal';

interface addDocument {
  documentID: any;
  count: number;
  setCount: any;
}

function AddNewVariationButton({ documentID, count, setCount }: addDocument) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        h="35px"
        w="fit-content"
        fontSize="15px"
        bg="#002677"
        textColor="white"
        mr="0.5rem"
        float="right"
        ml="auto"
        onClick={() => {
          onOpen();
        }}
      >
        Add Variation
      </Button>

      <AddNewVariationModal
        isOpen={isOpen}
        onClose={onClose}
        documentID={documentID}
        count={count}
        setCount={setCount}
      />
    </>
  );
}

export default AddNewVariationButton;
